import { render, staticRenderFns } from "./MediaIcon.vue?vue&type=template&id=57001819&"
import script from "./MediaIcon.vue?vue&type=script&lang=js&"
export * from "./MediaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports